import { Textarea as TextareaShad } from "@/components/ui/textarea"
import type { ComponentProps } from "react"
import type { UseFormReturn } from "react-hook-form"
import { Field } from "./Field"

type TextareaProps = {
  form: UseFormReturn
  name: string
  label?: string
  description?: string
  textareaProps?: Omit<ComponentProps<typeof TextareaShad>, "value" | "onChange" | "onBlur" | "name">
}

export const Textarea = ({
  form,
  name,
  label,
  description,
  textareaProps
}: TextareaProps) => {
  return (
    <Field
      form={form}
      name={name}
      label={label}
      description={description}
      render={field => <TextareaShad {...field} {...textareaProps} />}
    />
  )
}
